/**
* @file 公共组件-地址搜索
**/
<template>
  <div id="chooseAddress">
    <el-input v-model="address" class="area-input" ref="inputRef" :placeholder="placeholder" :disabled="disabled"
      @input="mapSearchFn(address)">
    </el-input>
    <div class="close-btn" v-if="address && !disabled">
      <span class="row-end tool-cursor-pointer" v-show="address" @click="clearFn">
        <i class="el-icon-error"></i>
      </span>
    </div>
    <div class="map-show" v-show="list && list.length > 0">
      <div class="row-result-col tool-cursor-pointer tool-animation-ease" v-for="(item, index) in list" :key="index"
        @click="clickRowFn(item)">
        <div class="icon">
          {{ index + 1 }}
        </div>
        <div class="val">
          <div class="result-col-name tool-animation-ease">{{ item.name }}</div>
          <div class="result-col-adds tool-animation-ease">
            {{ item.address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";

export default {
  name: "chooseAddress",
  props: {
    // 输入提示时限定城市
    citycode: {
      default() {
        return "全国";
      },
    },
    // 是否强制限制在设置的城市内搜索,默认值为：true
    citylimit: {
      default() {
        return false;
      },
    },
    // 输入框的值
    value: {
      default() {
        return "";
      },
    },
    // 输入框的占位符信息
    placeholder: {
      default() {
        return "请输入";
      },
    },
    // 禁用
    disabled: {
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      // 输入框中的信息
      address: "",
      // 可选地址列表
      list: [],
    };
  },
  watch: {
    value(val) {
      this.address = val;
    },
  },
  methods: {
    /* 输入提示 */
    mapSearchFn(keywords) {
      console.log('mapSearchFn 被调用, keywords:', keywords);
      console.log('citycode:', this.citycode);
      console.log('AMap 是否存在:', typeof AMap !== 'undefined');

      if (!keywords) {
        this.clearFn();
        return;
      }

      if (typeof AMap === 'undefined') {
        console.error('AMap 未定义，请检查高德地图是否正确加载');
        return;
      }

      let autocomplete = new AMap.Autocomplete({
        city: this.citycode || "全国",
        citylimit: this.citylimit,
        datatype: 'all'
      });
      
      console.log('autocomplete 实例创建成功:', autocomplete);
      
      // 使用箭头函数保持 this 上下文
      autocomplete.search(keywords, (status, result) => {
        console.log('搜索回调触发 - status:', status, 'result:', result);
        
        if (status === "complete" && result.info === "OK") {
          let addsResults = [];
          // 过滤没有经纬度的点
          result.tips.forEach((tip) => {
            if (tip.location) {
              if (tip.address instanceof Array) {
                tip.address = tip.district;
              }
              addsResults.push(tip);
            }
          });

          console.log('搜索结果处理完成, addsResults:', addsResults);
          this.list = addsResults;
          this.$emit("mapSearchFn", this.list);
        } else {
          console.error('搜索失败 - status:', status, 'result:', result);
        }
      });
    },
    /* 清除数据 */
    clearFn() {
      this.address = "";
      this.list = [];
      this.$emit("update:value", this.address);
      this.$emit("clearFn");
    },
    /* 关闭下拉选择地址框 */
    clearListFn() {
      this.list = [];
    },
    /* 点击单行 */
    clickRowFn(item) {
      this.address = item.name;
      this.$emit("update:value", this.address);
      this.$emit("clickRowFn", item);
      this.list = [];
    },
  },
};
</script>

<style lang="less">
#chooseAddress {
  display: inline-block;
  position: relative;

  .map-show {
    box-sizing: border-box;
    position: absolute;
    top: 100%;
    left: -16px;
    width: 300px;
    max-height: 600px;
    background-color: #fff;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
    z-index: 50;
    overflow-y: auto;
    padding: 8px 0;
    min-height: 160px;

    .row-result-col {
      box-sizing: border-box;
      width: 100%;
      padding: 5px 10px;
      line-height: 20px;
      display: flex;
      align-items: center;
    }

    .result-col-name {
      font-size: 14px;
      color: #1e8fe9;
    }

    .result-col-adds {
      font-size: 14px;
      color: #a1a1a1;
    }

    .row-result-col+.row-result-col {
      border-top: 1px dashed #eee;
    }

    .row-result-col:hover {
      background-color: #f0f0f0;
    }

    .icon {
      background: url(http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png) no-repeat;
      height: 31px;
      width: 19px;
      cursor: pointer;
      left: -1px;
      text-align: center;
      color: #fff;
      font: 12px arial, simsun, sans-serif;
      padding-top: 3px;
    }

    .val {
      padding-left: 8px;
      width: calc(~"100% - 45px");
    }
  }

  // 关闭按钮
  .close-btn {
    position: absolute;
    top: 7px;
    right: 5px;
  }
}
</style>
